﻿import { ArticleAllergen, ArticleSpecialAssortment } from '~/dtos/hub/hub.enums.generated.ts';
import {
  QUERY_SEARCH_PARAM_ALLERGEN,
  QUERY_SEARCH_PARAM_SPECIAL_ASSORTMENT
} from '~/features/catalog/mappers/catalogSearchQueryMapper.ts';

export function getAllergenLabel(id: number): string {
  return `label-${ArticleAllergen[id]}`;
}

export function getSpecialAssortmentLabel(id: number): string {
  return `label-${ArticleSpecialAssortment[id]}`;
}

export function getLabel(id: number, key: string) {
  switch (key) {
    case QUERY_SEARCH_PARAM_ALLERGEN:
      return getAllergenLabel(id);
    case QUERY_SEARCH_PARAM_SPECIAL_ASSORTMENT:
      return getSpecialAssortmentLabel(id);
    default:
      return '';
  }
}
